import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { PreviewSet } from "./routes";
import { DatasetDetails } from "Datasets/routes";

export default store => ({
  path: "standards",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-standards" */ "Datasets/components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [PreviewSet(store), DatasetDetails(store)],
});
